import { render } from "./propertiesImage.vue?vue&type=template&id=290f2542"
import script from "./propertiesImage.vue?vue&type=script&lang=js"
export * from "./propertiesImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__